import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'
import ScrollNavigation from 'containers/Project/ScrollNavigation/index'


import styles from './styles.scss'

const SpecificationNavigation = props => {
  const { categories, containerId } = props
  return (
    <Flex column styleName='specificationContainerDiv'>
      <h5>Project Specifications</h5>
      <ScrollNavigation categories={categories} containerId={containerId}/>
    </Flex>
  )
}

SpecificationNavigation.propTypes = {
}

export default CSSModules(SpecificationNavigation, styles)
